import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`
const SUGARCOACH_BASE_URL = `${process.env.REACT_APP_BACKEND_HOST}`

const axiosInstance = axios.create()

//요청 가로채기
axiosInstance.interceptors.request.use(
  //요청 보내기전 수행
  async function (config) {
    const recoilValue = localStorage.getItem('recoil-persist')
    // console.log('recoilValue = ', recoilValue)
    if (recoilValue !== null) {
      const parserdRecoilValue = JSON.parse(recoilValue)
      // console.log('tokenInfo = ', parserdRecoilValue?.token)
      if (
        parserdRecoilValue !== null &&
        parserdRecoilValue?.token?.accessToken &&
        parserdRecoilValue?.token?.refreshToken
      ) {
        // config.headers['x-dy-accesstoken'] =
        //   parserdRecoilValue.token.accessToken
        // config.headers['x-dy-refreshToken'] =
        //   parserdRecoilValue.token.refreshToken
      }
    }
    return config
  },
  //오류 요청
  function (err) {
    return Promise.reject(err)
  },
)

/**
 * 배너 카테고리 조회
 */
export const getBannerCategoryList = async (params) => {
  const res = await axios.get(`${SUGARCOACH_BASE_URL}/admin/banners-categories`)
  return res
}

/**
 * 배너 전체 조회
 * @returns
 */
export const getBannerList = async (params) => {
  const res = await axios.get(`${SUGARCOACH_BASE_URL}/admin/banners`, {
    params: params,
  })
  return res
}

/**
 * 배너 클릭 카운트 조회
 */
export const getBannerClickCount = async (params) => {
  const res = await axios.post(
    `${SUGARCOACH_BASE_URL}/admin/banners/click-count`,
    params,
  )
  // console.log('res', res)
  return res
}

/**
 * 배너 상세 조회
 */
export const getBannerDetail = async (bannerId) => {
  const res = await axios.get(
    `${SUGARCOACH_BASE_URL}/admin/banners/${bannerId}`,
    {
      bannerId: bannerId,
    },
  )
  return res
}

/**
 * 배너 내부 상세 페이지 버튼 클릭 타입 리스트
 */
export const getBannerDetailButtonActionNameList = async () => {
  const res = await axios.get(
    `${SUGARCOACH_BASE_URL}/admin/banners/detail-button-action-names`,
  )
  return res
}

export const updateBanner = async (params) => {
  const res = await axios.post(
    `${SUGARCOACH_BASE_URL}/admin/banners/update`,
    params,
  )
  return res
}

export const registerBanner = async (params) => {
  const res = await axios.post(`${SUGARCOACH_BASE_URL}/admin/banners`, params)
  return res
}

export const deleteBanner = async (bannerId) => {
  const res = await axios.delete(
    `${SUGARCOACH_BASE_URL}/admin/banners/${bannerId}`,
  )
  return res
}
